import ApiService from '@/services/ApiService';

const namespace = 'users';

const find = (id, options, callback, errorCallback) => {
    ApiService.get(`${namespace}/${id}`, options, callback, errorCallback);
};

const update = (id, options, callback, errorCallback) => {
    ApiService.put(`${namespace}/${id}`, options, callback, errorCallback);
};

const avatar = (id, options, callback, errorCallback) => {
    ApiService.post(`${namespace}/avatar/${id}`, options, callback, errorCallback, { headers: { 'Content-Type': 'multipart/form-data' } });
};

const activate = (id, options, callback, errorCallback) => {
    ApiService.put(`${namespace}/activate/${id}`, options, callback, errorCallback);
};

const deactivate = (id, options, callback, errorCallback) => {
    ApiService.put(`${namespace}/deactivate/${id}`, options, callback, errorCallback);
};

export default {
    find,
    update,
    avatar,
    activate,
    deactivate,
};



// WEBPACK FOOTER //
// ./src/taskflex/users/services/UserService.js